import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button1_click(event) {
	$w('#text32').show();
	$w('#button1').hide();
	$w('#button2').show();
	//Add your code for this event here: 
}



export function button4_click(event) {
	if ($w('#firstName').value === 'Trump') {
			$w('#box8').show();
			}
	else if ($w('#firstName').value === 'trump') {
			$w('#box8').show();
			}	
	else if ($w('#firstName').value === 'TRUMP') {
			$w('#box8').show();
			}
	
	else {
		wixWindow.openLightbox("try");
	}		
	//Add your code for this event here: 
}

export function button2_click(event) {
	$w('#text33').show();
	$w('#text32').hide();
	$w('#button2').hide();
	$w('#button3').show();
	//Add your code for this event here: 
}

export function button3_click(event) {
	$w('#button2').hide();
	$w('#button3').hide();
	$w('#text33').hide();
	$w('#text34').show();
	//Add your code for this event here: 
}

export function image27_viewportEnter(event) {
	// Add your code for this event here: 
}